import { cn } from '@workspace/ui/lib/utils'
import type { JSX, ReactNode } from 'react'

export interface TwoColumnLayoutProps {
  children: ReactNode
  className?: string
}

export interface TwoColumnLayoutCoverProps {
  title?: string
  description?: string
  className?: string
}

export interface TwoColumnLayoutContentProps {
  children: ReactNode
  className?: string
}

const TwoColumnLayoutCover = ({ title, description, className }: TwoColumnLayoutCoverProps) => {
  return (
    <section
      className={cn('relative flex flex-1 flex-col min-h-screen overflow-hidden', className)}
    >
      <div className="relative flex justify-center items-center p-6 h-full bg-black">
        <img src="/seedforge-full-light.svg" alt="SeedForge" className="w-1/2" />
        {title ? (
          <p className="text-sm uppercase tracking-[0.35em] text-white/70">{title}</p>
        ) : null}
        {description ? (
          <p className="text-lg font-semibold leading-snug sm:text-xl">{description}</p>
        ) : null}
      </div>
    </section>
  )
}

const TwoColumnLayoutContent = ({ children, className }: TwoColumnLayoutContentProps) => {
  return (
    <section className={cn('flex flex-1 items-center justify-center p-6 bg-background', className)}>
      {children}
    </section>
  )
}

type TwoColumnLayoutComponent = ((props: TwoColumnLayoutProps) => JSX.Element) & {
  Cover: typeof TwoColumnLayoutCover
  Content: typeof TwoColumnLayoutContent
}

export const TwoColumnLayout: TwoColumnLayoutComponent = ({ children, className }) => {
  return <div className={cn('flex min-h-screen w-full', className)}>{children}</div>
}

TwoColumnLayout.Cover = TwoColumnLayoutCover
TwoColumnLayout.Content = TwoColumnLayoutContent
